import { Injectable } from '@angular/core';

/**
 * Guarda el bearer token de URL_API en localStorage (clave `auth_token`) para que
 * la sesión sobreviva a recargas de página (F5).
 *
 * Nota de seguridad: localStorage es legible por cualquier script de la página,
 * por lo que un XSS podría leer el token.
 *
 * No depende de HttpClient para poder usarse dentro de interceptores sin
 * crear dependencias circulares.
 */
@Injectable({ providedIn: 'root' })
export class TokenService {
  private readonly STORAGE_KEY = 'auth_token';

  set(token: string): void {
    localStorage.setItem(this.STORAGE_KEY, token);
  }

  get(): string | null {
    return localStorage.getItem(this.STORAGE_KEY);
  }

  hasToken(): boolean {
    return !!this.get();
  }

  clear(): void {
    localStorage.removeItem(this.STORAGE_KEY);
  }
}
